module.exports = __webpack_public_path__ + "img/40_53.0bb3b72a.png";